import { Component } from '@angular/core';

@Component({
  selector: 'account-privacy',
  templateUrl: './account-privacy.component.pug',
  styleUrls: ['../account-common.component.scss'],
})
export class AccountPrivacyComponent {
}
